import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4fagdpccv: FaireProductEntity = {
  token: "p_a4fagdpccv",
  type: "product",
  name: "Kids Toddler Youth Long Sleeve Pullover T-shirt 6-PACK - DIY",
  brandToken: "b_58wn0038",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c0608e41a7da0f5c598792618b27a89074cd31cc934db747ec2253f97aed2712.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57a13d6d0876ff7da0ea299913c7a1c14d34fe1610c980a006c0f7fab243a094.jpeg",
    "https://cdn.faire.com/fastly/47817f8b853dbc95520ef894dbf63d3542ad36b5dee410fbf3c4aa4211e5bc3c.png",
    "https://cdn.faire.com/fastly/effac8109e270aa11ca26a8d5f0aaad7cbcfb757c2c7a7eb2324316f407d9ae1.jpeg",
    "https://cdn.faire.com/fastly/27bb908b8bb94e01d99d721b77ea3acd904845e621af5d63492e490e4a79a347.jpeg",
    "https://cdn.faire.com/fastly/f8e095b7769ccf7f3c7d8c7410a377c02150d72a014f505f77a95b7f72a52579.jpeg",
    "https://cdn.faire.com/fastly/a6964186f9fc4eeb4060bd4a735d21b53992a865d8eaefa5045bc9025dba0f9a.png",
    "https://cdn.faire.com/fastly/122dbd018038f6eb45e01e985cd2c8bec8c51a3d273ff07e9378155f9b68a232.jpeg",
  ],
  priceDollars: 59.59,
  description:
    "Polyester blend pullovers for sublimation. Please note these are lightweight and thinner than a sweatshirt. Sublimates with a retro/vintage look due to the 35% cotton blend. Ready for your next DIY project with its buttery soft feel.\n\nFEATURES:\n➼ Double-needle stitched sleeves and bottom hems. \n➼ Top stitched ribbed crew neck for easy dressing.\n➼ Moisture-wicking fabric that helps to keep cool and dry. \n\nIdeal For: Custom Gifts, DIY Projects, Personalized Gifts, I'm Going To Be a Big Sister Pregnancy Announcement, I'm Going To Be a Big Brother Pregnancy Announcement, Birthday Parties, Theme Park Shirts, Family Pictures, Valentine’s Day, St. Patrick's Day, Easter, Halloween, Christmas, New Years, Thanksgiving, 4th of July, Summer Nights, Fall, Autumn, Pumpkin Patches, Beach Days, Hay Rides, Spring. \nPersonalize these t-shirts with your child's initials, name or nickname.\n\nWe are The Laughing Giraffe based out of sunny So Cal. Sweatshop free & CPSIA compliant.",
  tags: [],
  msrpDollars: 119.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:07.491Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
